export default function PrivacyPolicy() {
    return (
        <h1>lol noob</h1>
    )
}